export const apiKey = (process.env.ALGOLIA_API_KEY as string) || "";
export const appId = (process.env.NEXT_PUBLIC_APP_ID as string) || "";
export const publicKey =
  (process.env.NEXT_PUBLIC_ALGOLIA_API_KEY as string) || "";
export const useMockAlgolia = process.env.USE_MOCK_ALGOLIA === "true";
